const menu_modules = localStorage.getItem("menu_modules");
const modules = menu_modules ? JSON.parse(menu_modules) : [];

const findModuleById = (moduleId, data = modules) => {
  for (const module of data) {
    if (module.module_id === moduleId) {
      return module;
    }
    if (module.inner && module.inner.length > 0) {
      const found = findModuleById(moduleId, module.inner);
      if (found) return found;
    }
  }
  return null;
};

export default findModuleById;
